
/**
* Sets up event listeners for an input element to clean its value of whitespace
*/

export function addPasswordInputValidation() {

    
var loginField = document.querySelector('#login-password');

        // Get the input element
        var loginField = document.querySelector('#login-password');

        
        if (loginField) {
            // Find the parent form to add submit event handler
            const parentForm = loginField.closest('form');
            if (parentForm) {

                // Add a submit event listener to the form
                parentForm.addEventListener('submit', function (event) {
                    // Clean the input value before submission
                    cleanInputValue(loginField);
                });
            } else {
                // Clean on blur (when user tabs/clicks away)
                inputElement.addEventListener('blur', function () {
                    cleanInputValue(loginField);
                });

            }
        }



/**
 * Cleans the value of an input element by removing leading and trailing whitespace
 */
function cleanInputValue(inputElement) {
    // Check if the element exists
    if (!inputElement) {
        return null;
    }

    // Get the current value, trim it, and update the input
    const originalValue = inputElement.value;

    const cleanedValue = originalValue.trim();
    inputElement.value = cleanedValue;

    // Return the cleaned value
    return cleanedValue;
}
}
